/* eslint-disable jsx-a11y/anchor-is-valid */
import { Row, Col, Skeleton, Button } from 'antd';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendarIcon.svg';
import { ReactComponent as FundingProgramsIcon } from 'assets/icons/fundingProgramsIcon.svg';
import { ReactComponent as ArrowRight } from 'assets/icons/ArrowRight.svg';
import { ReactComponent as SelectionIcon } from 'assets/icons/SelectionIcon.svg';
import { sectionTitleToLocalStateKeyMap } from '../../utils/mappers';
import ProgramCard from '../ProgramCard/ProgramCard';
import styles from './ProgramSection.module.scss';
import BudgetTable from '../budgetTable/BudgetTable';

export default function ProgramSection({
  title,
  programs,
  onViewAll,
  viewAllLabel = 'Δες τα όλα',
  loading,
  sectionTitle,
  response,
  // emptyMessage = 'Δεν υπάρχουν διαθέσιμα προγράμματα.',
}) {
  const handleView = e => {
    e.preventDefault();
    const key = sectionTitleToLocalStateKeyMap[title] || title;
    onViewAll?.(key);
  };

  if (!loading && (!programs || programs.length === 0)) {
    return null;
  }

  return (
    <>
      {title === 'Προτεινόμενος Συνδυασμός' &&
      !isEmpty(response?.fundingPrograms) ? (
        <div
          className={`${styles['funding-program-container']} ${
            loading ? styles['loading-section-container'] : ''
          }`}
        >
          <BudgetTable response={response} />

          <section
            style={{ marginBottom: 24 }}
            className={styles['funding-program-section-container']}
          >
            <div className={styles['program-section-header']}>
              <div className={styles['program-section-header-left-section']}>
                <FundingProgramsIcon />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className={styles['funding-program-section-title']}>
                    {title}
                  </span>
                  <span
                    style={{ marginTop: 7 }}
                    className={styles['funding-program-section-sub-title']}
                  >
                    {programs?.length} προγράμματα για τον πελάτη σου
                  </span>
                </div>
              </div>
            </div>

            {loading ? (
              <Row gutter={[16, 16]}>
                {Array.from({ length: 3 }).map((_, i) => (
                  <Col key={i}>
                    <Skeleton active avatar paragraph={{ rows: 4 }} />
                  </Col>
                ))}
              </Row>
            ) : (
              <Row gutter={[16, 16]}>
                {programs.map(p => (
                  <Col span={24} key={p.id}>
                    <ProgramCard program={p} />
                  </Col>
                ))}
              </Row>
            )}

            {/* Combination selection */}
            <div className={styles['selection-btn-container']}>
              <Button className={styles['selection-btn']} type="link">
                <Link to={`/main-forms/${response?.resultId}`}>
                  <SelectionIcon />
                  <span>Επιλογή Συνδυασμού</span>
                </Link>
              </Button>
            </div>
          </section>
        </div>
      ) : (
        <section
          style={{ marginBottom: 24 }}
          className={`${styles['program-section-container']} ${
            loading ? styles['loading-section-container'] : ''
          }`}
        >
          <div className={styles['program-section-header']}>
            <div className={styles['program-section-header-left-section']}>
              <CalendarIcon />
              <span className={styles['program-section-title']}>{title}</span>
            </div>

            {onViewAll && !sectionTitle && (
              <div className={styles['program-section-header-right-section']}>
                <a
                  href="#"
                  className={styles['btn-view-more']}
                  onClick={handleView}
                  role="button"
                >
                  {viewAllLabel}
                </a>
                <ArrowRight />
              </div>
            )}
          </div>

          {loading ? (
            <Row gutter={[16, 16]}>
              {Array.from({ length: 3 }).map((_, i) => (
                <Col key={i}>
                  <Skeleton active avatar paragraph={{ rows: 4 }} />
                </Col>
              ))}
            </Row>
          ) : (
            <Row gutter={[16, 16]}>
              {programs.map(p => (
                <Col span={24} key={p.id}>
                  <ProgramCard program={p} />
                </Col>
              ))}
            </Row>
          )}
        </section>
      )}
    </>
  );
}
